export enum PrsStatus {
  Unpaid = 'Unpaid',
  Ongoing = 'Ongoing',
  Paid = 'Paid',
  Cancelled = 'Cancelled',
  Submitted = 'Submitted',
}

export const PrsStatusOptions = [
  { id: PrsStatus.Unpaid, name: 'Unpaid' },
  { id: PrsStatus.Ongoing, name: 'Ongoing' },
  { id: PrsStatus.Paid, name: 'Paid' },
  { id: PrsStatus.Cancelled, name: 'Cancelled' },
  { id: PrsStatus.Submitted, name: 'Submitted' },
];
